import { defineComponent as _defineComponent } from 'vue'
import { toRefs, ref, watch } from 'vue';
import { suggestOriginalTitles } from '@/data-provider/materials';

type Emits = {
  (e: 'update:modelValue', originalTitle: string): void;
};
type Props = {
  originalTitle?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'OriginalTitle',
  props: {
    originalTitle: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', originalTitle: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  originalTitle?: string;
}




const { originalTitle } = toRefs(props);

const model = ref<string | undefined>(originalTitle.value);
const items = ref([originalTitle.value]);
const search = ref(null);
const isLoading = ref(false);

const rules = {
  trimmedString: (val: string) =>
    !/^\s+|\s+$|\s{2,}/.test(val) || 'Leading, trailing, or multiple whitespaces in a row are not allowed',
};

watch(search, async (val) => {
  if (!val || model.value === val) {
    items.value = [];
    return;
  }
  try {
    isLoading.value = true;
    items.value = await suggestOriginalTitles(val);
  } finally {
    isLoading.value = false;
  }
});

return { __sfc: true,emit, props, originalTitle, model, items, search, isLoading, rules }
}

})